import React from 'react';
import numeral from 'numeral';

import _ from '@ihme/common/locale';
import styled from '@ihme/common/theme/styled';
import config from "../../../../config";

const Article = styled.article(({ theme }) => ({
    backgroundColor: '#F5F7F8',
    padding: '35px 30px 0 30px',
    borderRadius: theme.borderRadius.base
}));

const Section = styled.section(({ theme }) => ({
    paddingBottom: 30
}));

const Header = styled.h2(({ theme, isHighlighted }) => ({
    marginTop: 0,
    marginBottom: 10,
    color: isHighlighted ? '#EF3828' : '#0094C9'
}));

type Props = {
    isLoading: boolean;
    locationId: number;
    data: {
        id: number;
        year: number;
        value: number;
    }[];
};

export default class View extends React.PureComponent<Props> {
    getLocationData = (locationId: number): {
        id: number;
        year: number;
        value: number;
    }[] => this.props.data.filter(record => record.id === locationId);

    formatValue(value) {
        return numeral(value)
            .format('0.00 a')
            .toUpperCase();
    }

    render() {
        const { locationId } = this.props;

        // @todo: add loading indicator
        return (
            <Article>
                <Section>
                    <Header>
                        {_('location_1')}
                        <div style={{fontSize: 12}}>Age Standardized, Rate per 100,000</div>
                    </Header>
                    {this.getLocationData(config.globalLocationId)
                        .map(data => (
                            <div key={data.year + ' ' + data.value}>
                                <p>
                                    <b>{data.year}</b>
                                    <br />
                                    {_('factsheets_scene_deaths_highlight_deaths', {
                                        amount: this.formatValue(data.value)
                                    })}
                                </p>
                            </div>
                        ))}
                </Section>

                <Section>
                    <Header isHighlighted={true}>
                        {_(`location_${locationId}`)}
                        <div style={{fontSize: 12}}>Age Standardized, Rate per 100,000</div>
                    </Header>
                    {this.getLocationData(locationId)
                        .map(data => (
                            <div key={data.year + ' ' + data.value}>
                                <p>
                                    <b>{data.year}</b>
                                    <br />
                                    {_('factsheets_scene_deaths_highlight_deaths', {
                                        amount: this.formatValue(data.value)
                                    })}
                                </p>
                            </div>
                        ))}
                </Section>
            </Article>
        );
    }
}
